import { kEmailSelector } from "@protontech/autofill/constants/selectors";
import { feature, flattenFeatures } from "@protontech/autofill/features/feature";
import {
  field,
  fieldAttrEmail,
  fieldAttrs,
  fieldAutocomplete,
  fieldAutocompleteEmail,
  fieldAutocompleteOff,
  fieldCC,
  fieldIdentity,
  fieldLabel,
  fieldSearch,
  fieldText,
  placeholder,
  type,
} from "@protontech/autofill/features/v1/abstract.field";
import { any } from "@protontech/autofill/utils/combinators";
import { matchEmail, matchEmailValue, matchMFAAttr } from "@protontech/autofill/utils/re";
import { sanitizeString } from "@protontech/autofill/utils/text";

export const typeEmail = feature("typeEmail", { fieldType: type }, (p) => p.type === "email");
export const exactAttrEmail = feature("exactAttrEmail", { field }, (p) => p.field.matches(kEmailSelector));
export const textEmail = feature("textEmail", { fieldText }, (p) => matchEmail(p.fieldText));
export const labelEmail = feature("labelEmail", { fieldLabel }, (p) => matchEmail(p.fieldLabel));
export const placeholderEmailValue = feature("placeholderEmailValue", { fieldPlaceholder: placeholder }, (p) => any(matchEmailValue)(p.placeholder.split(" ")));
export const placeholderEmail = feature("placeholderEmail", { placeholderEmailValue, fieldPlaceholder: placeholder }, (p) => p.placeholderEmailValue || matchEmail(sanitizeString(p.placeholder)));
export const mfaOutlier = feature("mfaOutlier", { fieldAttrs, fieldAutocomplete }, (p) => p.fieldAutocomplete === "one-time-code" || any(matchMFAAttr)(p.fieldAttrs));

export const emailFeatures = flattenFeatures({
  exactAttrEmail,
  fieldAttrEmail,
  fieldAutocompleteEmail,
  fieldAutocompleteOff,
  fieldCC,
  fieldIdentity,
  fieldSearch,
  labelEmail,
  mfaOutlier,
  placeholderEmail,
  textEmail,
  typeEmail,
});
